import React, { useState } from "react";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaPaperPlane,
} from "react-icons/fa";

function ContactSection() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      userEmail: "stratusinst@gmail.com",
      clientName: "STRATUS INSTRUMENTATION PVT. LTD. ENQUIRY",
      subject: "STRATUS INSTRUMENTATION PVT. LTD. ENQUIRY",
      description: `<p><strong class="ql-size-large">Name :</strong><span class="ql-size-large"> ${formData.name}</span></p><p><strong class="ql-size-large">Email : </strong><span class="ql-size-large"> ${formData.email}</span></p><p><strong class="ql-size-large">Mobile No : </strong><span class="ql-size-large"> ${formData.phone}</span></p><p><strong class="ql-size-large">Description : </strong><span class="ql-size-large"> ${formData.message}</span></p>`,
    };

    try {
      const response = await fetch("https://demo.bfiinfotech.co.in/api/email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
        // Optional: Add success feedback
      } else {
        console.error("Failed to send email:", response.status);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <section class="px-4 py-12 lg:px-16 text-white bg-[#092638F2]" id="contact">
      <div class="text-center mb-12">
        <h2 class="text-4xl font-bold mb-4">
          Let’s Shape the Future of Infrastructure Together
        </h2>
        <p class="text-gray-300 max-w-3xl mx-auto">
          Have a challenging project in mind? We’re ready to deliver smart
          engineering solutions that last. Get in touch with our experts and
          take the first step toward building excellence.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">

        {/* Left Info */}
        <div >
            <h3 className="font-bold text-lg mb-4">
              STRATUS INSTRUMENTATION PVT. LTD. – Regional Office
            </h3>
            <div className="flex items-start space-x-4">
              <div className="bg-orange-500 p-2 rounded-lg">
                <FaMapMarkerAlt className="text-white" />
              </div>
              <div>
                <p className="text-orange-500 font-semibold">
                  Navi Mumbai, INDIA
                </p>
                <p className="text-sm mt-1 mb-4 text-gray-300">
                  Siddhivinayak Residency,
                  <br />
                  Shop No-05 to 08, Sector-09, Plot No-40,
                  <br />
                  Kamothe, Navi Mumbai - 410209 MH
                </p>
              </div>
            </div>

            <div className="mb-4">
              <div className="flex items-center space-x-3 mb-2">
                <div className="bg-orange-500 p-2 rounded">
                  <FaPhone className="text-white" />
                </div>
                <div>
                  <p className="text-orange-500 font-semibold text-sm">
                    Phone Number
                  </p>
                  <a
                    href="tel:+917977047152"
                    className="text-sm text-gray-300 block hover:underline"
                  >
                    +91 74000 91415
                  </a>
                  {/* <a
                    href="tel:+919702677357"
                    className="text-sm text-gray-300 block hover:underline"
                  >
                    +91 97026 77357
                  </a> */}
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <div className="bg-orange-500 p-2 rounded">
                  <FaEnvelope className="text-white" />
                </div>
                <div>
                  <p className="text-orange-500 font-semibold text-sm">
                    Email Address
                  </p>
                  <a
                    href="mailto:stratusinst@gmail.com"
                    className="text-sm text-gray-300 hover:underline"
                  >
                    stratusinst@gmail.com
                  </a>
              </div>
            </div>
          </div>
        </div>

        {/* Map Section with Location Pin */}
        <div className="w-full h-[300px] md:h-full">
          <iframe
            title="Stratus Navi Mumbai Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3030.3628592482687!2d73.0971241!3d19.0201019!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7e9d1869c56bb%3A0x5df0559cbcc84ade!2sSIDDHIVINAYAK%20RESIDENCY%20KAMOTHE!5e1!3m2!1sen!2sin!4v1754559317274!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="rounded shadow-lg"
          ></iframe>
        </div>

        {/* Right Form */}
        <div className="bg-orange-500 p-6 rounded text-black">
          <h3 className="text-white font-bold text-2xl mb-2">Get In Touch</h3>
          <p className="text-white text-sm mb-6">
            Have questions or a project in mind? Send us a message and we’ll get
            back to you shortly.
          </p>
          <form className="space-y-4" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Name"
              required
              className="w-full p-2 rounded border-none outline-none"
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email Address"
              required
              className="w-full p-2 rounded border-none outline-none"
            />
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Mobile No."
              required
              className="w-full p-2 rounded border-none outline-none"
            />
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Write Here.."
              rows="4"
              required
              className="w-full p-2 rounded border-none outline-none"
            ></textarea>
            <button
              type="submit"
              className="bg-black text-white px-6 py-2 rounded hover:bg-gray-800 transition flex items-center space-x-2"
            >
              <span>Send Message</span>
              <FaPaperPlane />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

const Contact = () => {
  return (
    <div>
      <div
        className="h-[20rem] bg-cover relative bg-center flex items-center justify-start text-white"
        style={{
          backgroundImage: 'url("./img/service/contact.jpg")',
        }}
      >
        <h1 className="text-5xl font-bold text-white absolute top-1/3 left-1/4 sm:top-1/4 sm:left-1/3 md:top-1/4 md:left-1/4 lg:top-40 lg:left-28">
          Contact Us
        </h1>
      </div>
      {ContactSection()}
    </div>
  );
};

export default Contact;
